import { Injectable } from '@angular/core';
import { IGoogleMap, ILatLng } from 'src/app/core/models/google-map-models';
import { EventsService } from 'src/app/core/services/events.service';
import { AAGoogleMapEvents, GoogleMapEvents } from 'src/app/core/events/events';
import { GoogleInfoWindowService } from '../google-info-window/google-info-window.service';
import { RouteLeg } from 'src/app/modules/route-planner/models/route-signposts-model';
import { MarkerType } from '../../enums/google-map-enum';
import { GoogleMapStoreService } from '../google-map-store/google-map-store.service';
import { AAGoogleIconService } from 'src/app/modules/aa-core/services/google/aa-google-icon/aagoogle-icon.service';
import { GoogleMapGeoService } from 'src/app/modules/aa-core/services/google/aa-google-geo/google-map-geo.service';
import { GoogleMapMarkerData } from '../../models/google-map-model';
import { RoutePlannerDataModel } from 'src/app/modules/route-planner/models/route-model';

export interface IGoogleMapRouteService {
  // clearDirectionMaker(): void;
}



@Injectable({
  providedIn: 'root'
})
export class GoogleMapRouteService implements IGoogleMapRouteService {

  constructor(
    private googleMapStore: GoogleMapStoreService,
    private googleIconService: AAGoogleIconService,
    private googleMapGeoUtils: GoogleMapGeoService,
    private googleInfoWindow: GoogleInfoWindowService,
    public eventsService: EventsService) {

    this.eventsService.on(AAGoogleMapEvents.HIGHLIGHT_ROUTE, this.highlightAlternativeRoute);
    this.eventsService.on(AAGoogleMapEvents.ROUTE_LEG_HOVER, this.highlightAlternativeLeg);
    this.eventsService.on(AAGoogleMapEvents.ROUTE_LEG_CLICK, this.alternativeLegSelected);
  }

  private routeOverlay: any;
  // private routeDirectionMarker: Array<any> = [];
  private circleDotMarker: any;
  private circleDotIcon: any;
  private highlightRoute: any;
  private readonly stokeColor: string = '#1685F4';

  private getRouteMarkerData(routeDataModel: RoutePlannerDataModel, draggable: boolean = false): Array<GoogleMapMarkerData> {
    const markersList: Array<GoogleMapMarkerData> = [];
    let markerData: GoogleMapMarkerData;

    markerData = new GoogleMapMarkerData();
    markerData.latLng = routeDataModel.FromLocation.latLng;
    markerData.placeName = routeDataModel.FromLocation.Name;
    markerData.index = markersList.length;
    markerData.itemIndx = markersList.length;
    markerData.type = MarkerType.ORIGIN;
    markerData.draggable = draggable;
    markersList.push(markerData);

    const viaRoutes = routeDataModel.ViaRoutes;
    for (let wpCounter = 0; wpCounter < viaRoutes.length; wpCounter++) {
      markerData = new GoogleMapMarkerData();
      markerData.id = wpCounter;
      markerData.latLng = viaRoutes[wpCounter].latLng;
      markerData.placeName = viaRoutes[wpCounter].Name;
      markerData.index = markersList.length;
      markerData.itemIndx = markersList.length;
      markerData.type = MarkerType.WAYPOINT;
      markerData.draggable = draggable;
      markersList.push(markerData);
    }

    markerData = new GoogleMapMarkerData();
    markerData.latLng = routeDataModel.ToLocation.latLng;
    markerData.placeName = routeDataModel.ToLocation.Name;
    markerData.index = markersList.length;
    markerData.itemIndx = markersList.length;
    markerData.type = MarkerType.DESTINATION;
    markerData.draggable = draggable;
    markersList.push(markerData);

    return markersList;
  }

  public updateDirectionMarker(googleMap: IGoogleMap, routeDataModel: RoutePlannerDataModel, draggable: boolean = false): Array<any> {
    // this.clearDirectionMaker();
    const routeDirectionMarker: Array<any> = [];

    const routeMarkersData: Array<GoogleMapMarkerData> = this.getRouteMarkerData(routeDataModel, draggable);
    for (let index = 0; index < routeMarkersData.length; index++) {
      const marker = this.createRouteDirectionMarker( googleMap, routeMarkersData[index] );
      routeDirectionMarker.push( marker );
    }
    return routeDirectionMarker;
  }

  private getPolyLine(selectedRoute: any): any {
    const polyOptions = {
      strokeColor: this.stokeColor,
      strokeWeight: 8,
      clickable: false,
      strokeOpacity: 0.5,
      path: this.createPolyLinePath(selectedRoute)
    };

    return new google.maps.Polyline(polyOptions);
  }

  clearMarkers() {
    this.clearDirectionMaker([]);

    if (this.highlightRoute) {
      this.highlightRoute.setMap(null);
      this.highlightRoute = null;
    }
  }

  public clearDirectionMaker(routeDirectionMarker): void {
    if (routeDirectionMarker.length) {
      for (let i = 0; i < routeDirectionMarker.length; i++) {
        routeDirectionMarker[i].setMap(null);
        routeDirectionMarker[i] = null;
      }
    }
    routeDirectionMarker = [];
  }

  public removeRoutingDirectionPloygon = () => {
    if (this.routeOverlay) {
      this.routeOverlay.setMap(null);
    }

    this.googleInfoWindow.close();
    // this.clearDirectionMaker();
    this.clearMarkers();
  }

  private createPolyLinePath(currentRouteData) {
    let polyPath = [], groute: any = {};

    // Loop through each route in the GDirections object
    for (let i = 0; i < currentRouteData.legs.length; i++) {
      groute = currentRouteData.legs[i];

      // Loop through all the steps in the route
      for (let j = 0; j < groute.steps.length; j++) {
        const gstep = groute.steps[j];
        if ( gstep.hasOwnProperty('polyline') &&  gstep.polyline !== null &&
             gstep.polyline.hasOwnProperty('points') && gstep.polyline.points !== null ) {
          polyPath = polyPath.concat( this.googleMapGeoUtils.decode(gstep.polyline.points) );
        }
      }
    }

    return polyPath;
  }

  public renderAARoutePath = currentRouteData => {
    const polyPath = this.createPolyLinePath(currentRouteData.routes[0]);

    // display polyline
    this.addDecodedRouteOverlay(polyPath);
  }

  // alternative legs
  alternativeLegSelected = (params) => {
    const googleMap = this.googleMapStore.getGoogleMap();
    const leg: RouteLeg = params.leg;
    const latLog = leg.location;
    this.setMapToCenter(googleMap, latLog);
  }

  setMapToCenter(googleMap: IGoogleMap, latLng: ILatLng): void {
    const currentZoomLevel = googleMap.getZoom();
    if (currentZoomLevel < 16) {
      googleMap.setZoom(16);
    }  else {
      googleMap.setZoom(currentZoomLevel);
    }
    googleMap.setCenter(new google.maps.LatLng(latLng.lat, latLng.lng));
  }

  private highlightAlternativeLeg = (params) => {
    this.clearMarker(this.circleDotMarker);
    const googleMap = this.googleMapStore.getGoogleMap();

    if (params.visible) {
      this.addDecodedRoundRouteOverlay(googleMap,  params.leg );
    }
  }

  clearMarker(thisMarker: any) {
    if (thisMarker) {
      thisMarker.setMap(null);
      thisMarker = null;
    }
  }

  public addDecodedRoundRouteOverlay = (googleMap: IGoogleMap, decPoints: RouteLeg) => {
    if (!this.circleDotIcon) {
        this.circleDotIcon = {
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: 'white',
          fillOpacity: 1,
          scale: 8,
          strokeColor: 'black',
          strokeWeight: 2
      };
    }

    this.circleDotMarker = new google.maps.Marker({
        position: decPoints.location,
        map: googleMap,
        icon: this.circleDotIcon, // set the icon here
    });
  }

  private highlightAlternativeRoute = (options: {route: any, visible: boolean}) => {
    const googleMap = this.googleMapStore.getGoogleMap();

    if (options.visible && !this.highlightRoute) {
      this.highlightRoute = this.getPolyLine(options.route);
      this.highlightRoute.setMap(googleMap);
    } else if (options.visible == false && this.highlightRoute) {
      this.highlightRoute.setMap(null);
      this.highlightRoute = null;
    }
  }
  private addDecodedRouteOverlay = decPoints => {
    const googleMap = this.googleMapStore.getGoogleMap();

    const polyOptions = {
      strokeColor: this.stokeColor,
      strokeWeight: 10,
      clickable: false,
      strokeOpacity: 0.7,
      path: decPoints
    };

    if (!this.routeOverlay) {
      this.routeOverlay = new google.maps.Polyline(polyOptions);
    } else {
      this.routeOverlay.setOptions(polyOptions);
    }
    this.routeOverlay.setMap(googleMap);
  }

  private createRouteDirectionMarker = (googleMap: IGoogleMap,  markerData: GoogleMapMarkerData) => {
    const labels = 'ABCDEFGHIJ';
    const icon = this.googleIconService.getDirectionIcon();
    const iconShadow = this.googleIconService.iconShadow();

    const IconShape = {
      coords: [0, 0, 26, 34],
      type: 'rect'
    };

    const labelObj = {
      text: labels[markerData.index],
      // color: 'white',
      fontSize: '16px',
      fontWeight: 'bold',
    };

    const marker = new google.maps.Marker({
      position: markerData.latLng,
      map: googleMap,
      title: '',
      shape: IconShape,
      shadow: iconShadow,
      icon: icon,
      label: labelObj,
      html: markerData.placeName,
      routePosition: markerData.index,
      type: markerData.type,
      itemIndex: markerData.itemIndx,
      zIndex: 99990 + markerData.itemIndx
    });

    if (markerData.draggable) {
      marker.setDraggable(true);
    }

    google.maps.event.addListener(marker, GoogleMapEvents.CLICK, e => {
      this.googleInfoWindow.setContent(markerData.placeName);
      this.googleInfoWindow.open(googleMap, marker);
    });

    google.maps.event.addListener(marker, GoogleMapEvents.DRAG_END, (event) => {
      markerData.draggedLatLng = {lat: event.latLng.lat(), lng: event.latLng.lng()};
      this.eventsService.dispatch(AAGoogleMapEvents.MARKER_DRAG_END, markerData);
    });

    return marker;
  }
}
